module.exports = __webpack_public_path__ + "img/Bookit-dark-logo.6d33ff89.svg";